module.exports = __webpack_public_path__ + "static/img/strong_8.23112171.png";